export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_TEST":
      return [...state, action.payload.test];
    case "UPDATE_TESTS":
      return action.payload.tests || [];
    case "DELETE_TEST":
      return state.filter((test) => {
        return test.id !== action.payload.test.id
      });
    default:
      return state;
  }
}
